import { useQuery } from "@apollo/client";
import {
  GetAccountProductPreferencesDocument,
  GetAccountProductPreferencesQuery,
} from "/@/generated/graphql";

export type AccountProductPreferences =
  GetAccountProductPreferencesQuery["getAccountProductPreferences"][number];

export function useAccountProductPreferences(): (
  dentistId: string
) => Promise<AccountProductPreferences> {
  const { data } = useQuery(GetAccountProductPreferencesDocument, {
    fetchPolicy: "network-only",
  });

  return async (dentistId: string) => {
    return data!.getAccountProductPreferences.find(
      preference => preference.dentist.id === dentistId
    )!;
  };
}
